/**
 * ============================================================================
 * 🔒🔒🔒 永久锁死代码 - 管理员 F12 功能 🔒🔒🔒
 * ============================================================================
 * 
 * ⚠️⚠️⚠️ 绝对禁止修改此文件中的以下内容：
 * 1. ADMIN_EMAIL 常量值 '276517619@qq.com'
 * 2. isAdmin() 函数中的邮箱匹配逻辑
 * 3. enableDevTools() 函数中的管理员启用逻辑
 * 4. initDevToolsProtection() 函数中的管理员判断逻辑
 * 
 * 🚫 禁止修改原因：
 * - 276517619@qq.com 作为管理员必须能够按 F12 打开开发者工具
 * - 这是核心功能，任何修改都可能导致管理员无法使用 F12
 * - 即使修改其他代码，也不能影响这个功能
 * 
 * 📅 锁死日期：2026-02-08
 * 🔒🔒🔒 未经用户明确要求，绝对禁止修改以下代码 🔒🔒🔒
 * ============================================================================
 * 
 * 开发者工具保护
 * 除了管理员外，禁止所有用户打开开发者工具
 */

// ============================================================================
// 🔒🔒🔒 永久锁死 - 管理员邮箱常量 🔒🔒🔒
// ⚠️⚠️⚠️ 绝对禁止修改此常量值！
// 功能：定义管理员邮箱，只有此邮箱可以打开 F12
// 值：'276517619@qq.com' - 这是唯一的管理员邮箱，绝对不能改！
// 锁死日期：2026-02-08
// 🔒🔒🔒 即使修改其他代码，也不能修改这个值 🔒🔒🔒
// ============================================================================
const ADMIN_EMAIL = '276517619@qq.com';

/**
 * ============================================================================
 * 🔒🔒🔒 永久锁死 - 管理员判断函数 🔒🔒🔒
 * ============================================================================
 * ⚠️⚠️⚠️ 绝对禁止修改此函数的逻辑！
 * 功能：判断用户是否是管理员（276517619@qq.com）
 * 返回值：true = 是管理员，false = 不是管理员
 * 锁死日期：2026-02-08
 * 🔒🔒🔒 即使修改其他代码，也不能修改这个函数的逻辑 🔒🔒🔒
 * ============================================================================
 */
export const isAdmin = (userEmail: string | null | undefined): boolean => {
  // 🔒🔒🔒 永久锁死 - 管理员邮箱匹配检查 🔒🔒🔒
  // ⚠️⚠️⚠️ 绝对禁止修改此处的匹配逻辑！
  // 必须严格匹配 '276517619@qq.com'，不能使用模糊匹配或其他逻辑
  // 🔒🔒🔒 即使修改其他代码，也不能修改这个判断 🔒🔒🔒
  return userEmail === ADMIN_EMAIL;
};

/**
 * 禁用开发者工具（非管理员）
 */
export const disableDevTools = () => {
  console.log('🔒 [开发者工具保护] 已启用（非管理员）');
  
  // 禁用 F12
  document.addEventListener('keydown', (e) => {
    // F12
    if (e.key === 'F12' || e.keyCode === 123) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Ctrl + Shift + I (Chrome DevTools)
    if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.keyCode === 73)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Ctrl + Shift + J (Chrome Console)
    if (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.keyCode === 74)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Ctrl + Shift + C (Chrome Element Inspector)
    if (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.keyCode === 67)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Ctrl + U (View Source)
    if (e.ctrlKey && (e.key === 'u' || e.key === 'U' || e.keyCode === 85)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
    
    // Ctrl + S (Save Page - 可能用于保存源代码)
    if (e.ctrlKey && (e.key === 's' || e.key === 'S' || e.keyCode === 83)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // 禁用右键菜单
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }, true);

  // 禁用文本选择（可选，如果不需要用户选择文本可以启用）
  // document.addEventListener('selectstart', (e) => {
  //   e.preventDefault();
  //   return false;
  // }, true);

  // 检测开发者工具是否被打开（通过检测窗口大小变化）
  let devtools = {
    open: false,
    orientation: null as 'vertical' | 'horizontal' | null
  };

  const threshold = 160;
  
  setInterval(() => {
    if (window.outerHeight - window.innerHeight > threshold || 
        window.outerWidth - window.innerWidth > threshold) {
      if (!devtools.open) {
        devtools.open = true;
        // 可以在这里添加额外的保护措施
        // 例如：重定向、清除敏感数据等
        console.clear();
        console.log('%c⚠️ 禁止使用开发者工具', 'color: red; font-size: 50px; font-weight: bold;');
        console.log('%c此操作已被禁止', 'color: red; font-size: 20px;');
      }
    } else {
      devtools.open = false;
    }
  }, 500);

  // 禁用控制台输出（通过重写 console 方法）
  const noop = () => {};
  const originalConsole = {
    log: console.log,
    warn: console.warn,
    error: console.error,
    info: console.info,
    debug: console.debug
  };

  // 重写 console 方法（可选，如果完全禁用控制台）
  // console.log = noop;
  // console.warn = noop;
  // console.error = noop;
  // console.info = noop;
  // console.debug = noop;
};

// 🔥 全局监控器引用，用于清理
let adminModeMonitorInterval: NodeJS.Timeout | null = null;
let adminModeCheckCount = 0;
const MAX_CHECK_COUNT = 10000; // 最大检查次数，防止无限循环

/**
 * ============================================================================
 * 🔒🔒🔒 永久锁死 - 管理员 F12 启用功能 🔒🔒🔒
 * ============================================================================
 * ⚠️⚠️⚠️ 绝对禁止修改此函数的逻辑！
 * 功能：允许管理员（276517619@qq.com）使用 F12 打开开发者工具
 * 此函数必须确保管理员能够正常使用 F12，不能有任何限制
 * 锁死日期：2026-02-08
 * 🔒🔒🔒 即使修改其他代码，也不能修改这个函数 🔒🔒🔒
 * ============================================================================
 */
export const enableDevTools = () => {
  // 管理员可以正常使用开发者工具，不需要做任何限制
  // 调用 window.enableDevToolsForAdmin 来移除 index.html 中添加的保护
  if (typeof window !== 'undefined') {
    // 🔥 设置全局变量，确保立即生效（最高优先级）
    (window as any).__isAdminMode = true;
    
    // 🔥 多重设置方式，确保在所有情况下都能生效
    try {
      // 方式1: 直接赋值
      (window as any).__isAdminMode = true;
      
      // 方式2: 使用 defineProperty（更可靠，防止被覆盖）
      try {
        Object.defineProperty(window, '__isAdminMode', {
          value: true,
          writable: true,
          configurable: true,
          enumerable: true
        });
      } catch (e) {
        // 如果 defineProperty 失败，继续使用直接赋值
        (window as any).__isAdminMode = true;
      }
      
      // 方式3: 设置到 window 对象上（备用）
      if (!(window as any).__isAdminMode) {
        (window as any).__isAdminMode = true;
      }
    } catch (e) {
      // 如果所有方式都失败，至少尝试直接设置
      try {
        (window as any).__isAdminMode = true;
      } catch (e2) {
        console.error('🔓 [管理员模式] 设置 __isAdminMode 失败:', e2);
      }
    }
    
    // 🔥 立即保存到 localStorage，方便 index.html 检测
    try {
      localStorage.setItem('__isAdminMode', 'true');
    } catch (e) {
      // 忽略错误
    }
    
    // 调用函数（如果存在）
    if ((window as any).enableDevToolsForAdmin) {
      try {
        (window as any).enableDevToolsForAdmin();
      } catch (e) {
        console.error('🔓 [管理员模式] 调用 enableDevToolsForAdmin 失败:', e);
      }
    }
    
    // 🔥 额外检查：确保全局变量已设置
    const currentValue = (window as any).__isAdminMode;
    console.log('🔓 [管理员模式] 开发者工具已启用');
    console.log('🔓 [管理员模式] __isAdminMode =', currentValue);
    console.log('🔓 [管理员模式] 检查 window.__isAdminMode =', window.__isAdminMode);
    
    // 🔥 如果设置失败，记录警告
    if (!currentValue) {
      console.error('⚠️ [管理员模式] 警告：__isAdminMode 设置失败！');
    }
    
    // 🔥 多次延迟设置，确保在所有事件监听器检查之前生效
    const delays = [50, 100, 200, 500, 1000, 2000, 3000, 5000];
    delays.forEach((delay, index) => {
      setTimeout(() => {
        (window as any).__isAdminMode = true;
        if (index < 3) { // 只记录前几次的日志，避免日志过多
          console.log(`🔓 [管理员模式] 延迟${delay}ms设置完成，__isAdminMode =`, (window as any).__isAdminMode);
        }
      }, delay);
    });
    
    // 🔥 清理旧的监控器（如果存在）
    if (adminModeMonitorInterval) {
      clearInterval(adminModeMonitorInterval);
      adminModeMonitorInterval = null;
    }
    
    // 🔥 持续监控，确保 __isAdminMode 始终为 true（更频繁的检查）
    adminModeCheckCount = 0;
    adminModeMonitorInterval = setInterval(() => {
      adminModeCheckCount++;
      
      // 防止无限循环
      if (adminModeCheckCount > MAX_CHECK_COUNT) {
        console.warn('⚠️ [管理员模式] 达到最大检查次数，停止监控');
        if (adminModeMonitorInterval) {
          clearInterval(adminModeMonitorInterval);
          adminModeMonitorInterval = null;
        }
        return;
      }
      
      const currentValue = (window as any).__isAdminMode;
      if (!currentValue || currentValue !== true) {
        console.warn(`⚠️ [管理员模式] 检测到 __isAdminMode 被重置为 ${currentValue}，正在恢复... (检查次数: ${adminModeCheckCount})`);
        // 立即恢复
        (window as any).__isAdminMode = true;
        
        // 再次尝试使用 defineProperty
        try {
          Object.defineProperty(window, '__isAdminMode', {
            value: true,
            writable: true,
            configurable: true,
            enumerable: true
          });
        } catch (e) {
          // 忽略错误，继续尝试
        }
        
        // 调用启用函数（如果存在）
        if ((window as any).enableDevToolsForAdmin) {
          try {
            (window as any).enableDevToolsForAdmin();
          } catch (e) {
            // 忽略错误
          }
        }
      }
    }, 1000); // 🔥 每1秒检查一次（更频繁）
    
    // 在页面卸载时清理监控
    window.addEventListener('beforeunload', () => {
      if (adminModeMonitorInterval) {
        clearInterval(adminModeMonitorInterval);
        adminModeMonitorInterval = null;
      }
    });
    
    // 🔥 添加页面可见性变化监听，确保在页面重新可见时也检查
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        // 页面重新可见时，立即检查并恢复
        if (!(window as any).__isAdminMode) {
          console.log('🔓 [管理员模式] 页面重新可见，恢复管理员模式');
          (window as any).__isAdminMode = true;
        }
      }
    });
    
    // 🔥 添加焦点变化监听，确保在窗口重新获得焦点时也检查
    window.addEventListener('focus', () => {
      if (!(window as any).__isAdminMode) {
        console.log('🔓 [管理员模式] 窗口重新获得焦点，恢复管理员模式');
        (window as any).__isAdminMode = true;
      }
    });
  }
};

/**
 * ============================================================================
 * 🔒🔒🔒 永久锁死 - 开发者工具保护初始化 🔒🔒🔒
 * ============================================================================
 * ⚠️⚠️⚠️ 绝对禁止修改此函数中的管理员判断逻辑！
 * 功能：根据用户邮箱判断是否是管理员，管理员可以打开 F12，其他用户不能
 * 关键逻辑：必须使用 isAdmin() 函数判断，不能直接比较邮箱
 * 锁死日期：2026-02-08
 * 🔒🔒🔒 即使修改其他代码，也不能修改这个函数中的管理员判断逻辑 🔒🔒🔒
 * ============================================================================
 */
/**
 * 诊断管理员模式状态
 */
export const diagnoseAdminMode = () => {
  if (typeof window === 'undefined') {
    console.error('🔍 [诊断] window 对象不存在');
    return;
  }
  
  const adminMode = (window as any).__isAdminMode;
  const userEmail = localStorage.getItem('userEmail') || '未找到';
  
  console.log('🔍 [诊断] ========== 管理员模式诊断 ==========');
  console.log('🔍 [诊断] __isAdminMode:', adminMode);
  console.log('🔍 [诊断] __isAdminMode 类型:', typeof adminMode);
  console.log('🔍 [诊断] 用户邮箱:', userEmail);
  console.log('🔍 [诊断] 是否匹配管理员:', userEmail === ADMIN_EMAIL);
  console.log('🔍 [诊断] enableDevToolsForAdmin 函数存在:', typeof (window as any).enableDevToolsForAdmin === 'function');
  console.log('🔍 [诊断] 监控器运行中:', adminModeMonitorInterval !== null);
  console.log('🔍 [诊断] ====================================');
  
  return {
    adminMode,
    userEmail,
    isAdmin: userEmail === ADMIN_EMAIL,
    enableDevToolsForAdminExists: typeof (window as any).enableDevToolsForAdmin === 'function',
    monitorRunning: adminModeMonitorInterval !== null
  };
};

// 🔥 暴露诊断函数到全局，方便在控制台调用
if (typeof window !== 'undefined') {
  (window as any).diagnoseAdminMode = diagnoseAdminMode;
  console.log('🔍 [诊断] 诊断函数已暴露到全局，可在控制台调用: diagnoseAdminMode()');
}

export const initDevToolsProtection = (userEmail: string | null | undefined) => {
  console.log('🔒 [开发者工具保护] 初始化，用户邮箱:', userEmail);
  console.log('🔒 [开发者工具保护] 管理员邮箱:', ADMIN_EMAIL);
  console.log('🔒 [开发者工具保护] 是否匹配:', userEmail === ADMIN_EMAIL);
  console.log('🔒 [开发者工具保护] 当前 __isAdminMode:', (window as any).__isAdminMode);
  
  // 🔒🔒🔒 锁死代码 - 管理员判断和启用逻辑 🔒🔒🔒
  if (isAdmin(userEmail)) {
    console.log('✅ [开发者工具保护] 管理员模式，允许使用开发者工具');
    
    // 🔥 立即启用，并多次确保生效
    enableDevTools();
    
    // 🔥 延迟再次启用，确保在所有事件监听器检查之前生效
    const enableDelays = [50, 100, 200, 500, 1000, 2000, 3000, 5000];
    enableDelays.forEach((delay, index) => {
      setTimeout(() => {
        if (index < 4) { // 只记录前几次的日志
          console.log(`🔄 [开发者工具保护] 延迟${delay}ms再次启用管理员模式`);
        }
        enableDevTools();
      }, delay);
    });
    
    // 🔥 定期重新启用（每10秒一次，作为备用保护）
    const periodicEnable = setInterval(() => {
      const currentValue = (window as any).__isAdminMode;
      if (!currentValue) {
        console.log('🔄 [开发者工具保护] 定期检查：__isAdminMode 为 false，正在恢复...');
        enableDevTools();
      }
    }, 10000); // 每10秒检查一次
    
    // 在页面卸载时清理
    window.addEventListener('beforeunload', () => {
      clearInterval(periodicEnable);
    });
    
    // 🔥 保存用户邮箱到 localStorage，方便诊断
    try {
      localStorage.setItem('userEmail', userEmail || '');
    } catch (e) {
      // 忽略错误
    }
  } else {
    // 🔒🔒🔒 锁死代码 - 普通用户禁用开发者工具 🔒🔒🔒
    console.log('🔒 [开发者工具保护] 普通用户模式，禁用开发者工具');
    // 🔥 确保普通用户模式下 __isAdminMode 为 false
    if (typeof window !== 'undefined') {
      (window as any).__isAdminMode = false;
    }
    // 🔥 清理监控器（如果存在）
    if (adminModeMonitorInterval) {
      clearInterval(adminModeMonitorInterval);
      adminModeMonitorInterval = null;
    }
    disableDevTools();
  }
};
